/* Project settings page: the sections of the nav, their labels and anchors. Pure, shared by the page and its nav. */
import type { Project } from '@hangar/shared';
import { liveEnvironments } from './environmentLabels';

export const PROJECT_SETTINGS_SECTIONS = ['general', 'environments', 'members', 'limits', 'danger'] as const;
export type ProjectSettingsSection = (typeof PROJECT_SETTINGS_SECTIONS)[number];
export interface ProjectSettingsSearch {
  section?: ProjectSettingsSection;
}

/**
 * The sections the nav offers: no Members (project members stay API-only in the MVP, docs/mvp-plan.md P4; the type keeps
 * `members` so old `?section=members` links still parse).
 */
export const NAV_SECTIONS: readonly ProjectSettingsSection[] = PROJECT_SETTINGS_SECTIONS.filter((s) => s !== 'members');

export const SECTION_LABEL: Record<ProjectSettingsSection, string> = { general: 'General', environments: 'Environments', members: 'Members', limits: 'Limits', danger: 'Danger zone' };

/** The DOM id of a section's card (also the `#` target of its nav link). */
export const sectionAnchor = (s: ProjectSettingsSection): string => `settings-${s}`;

/** The little badge next to a nav entry: the live environments. */
export function sectionCounts(project: Project): Partial<Record<ProjectSettingsSection, string>> {
  return { environments: String(liveEnvironments(project).length) };
}
